import React, {useState} from 'react';
import BackButton from '../../../CommonComponents/BackButton/BackButton';
import RadioButton from '../../../CommonComponents/RadioButton/RadioButton';
import TextInput from '../../../CommonComponents/TextInput/TextInput';
import Spinner from '../../../CommonComponents/Spinner/Spinner';

import * as S from './SkipPanVerification.styles';

const SkipPanVerification = ({
  onBackPress,
  options,
  infoText,
  infoIcon,
  cta,
  handleSkipPanVerification,
  handleSubmit,
  setOtherReasonToSkip,
  otherReasontoSkip,
  submitSkipVerifyPan,
}) => {
  const winSize = window.screen;

  const [selected, setSelected] = useState(null);
  const [error, setError] = useState('');

  const handleChange = idx => {
    setSelected(idx);
    handleSkipPanVerification && handleSkipPanVerification(idx);
  };

  const handleSubmitButton = () => {
    if (selected === 3 && otherReasontoSkip === '') {
      setError('Please mention the other reason');
    } else {
      handleSubmit();
    }
  };

  return (
    <S.SkipPan>
      <S.SkipPanHdr>
        <BackButton onBackPress={onBackPress} arrow={true} />
      </S.SkipPanHdr>
      <S.Heading>Select reason for not verifying PAN</S.Heading>
      {infoText && winSize.width < 768 && (
        <S.Info className="appendTop10">
          <span className="icon">
            <img src={infoIcon} alt="" />
          </span>
          <p>{infoText}</p>
        </S.Info>
      )}
      {options && options.length > 0 && (
        <S.SkipOptions>
          {options.map((item, index) => (
            <li key={item.id}>
              <RadioButton name={'skip'} id={item.id} onChange={() => handleChange(index)}>
                <p className={`font14 blackText ${selected === index && 'latoBold'}`}>
                  {item.text}
                </p>
              </RadioButton>
              {selected === 3 && index === 3 && (
                <S.OtherField>
                  <TextInput placeholder="Please specify" setterObj={setOtherReasonToSkip} />
                </S.OtherField>
              )}
            </li>
          ))}
        </S.SkipOptions>
      )}
      <S.SkipPanFtr>
        {infoText && winSize.width > 768 && (
          <S.Info>
            <span className="icon">
              <img src={infoIcon} alt="" />
            </span>
            <p>{infoText}</p>
          </S.Info>
        )}
        {cta && (
          <button className="primaryBtn" onClick={handleSubmitButton}>
            {cta}
          </button>
        )}
        {submitSkipVerifyPan && <Spinner width="14px" height="14px" borderWidth="4px" />}
      </S.SkipPanFtr>
      {error && selected === 3 && <S.ErrMsg>{error}</S.ErrMsg>}
    </S.SkipPan>
  );
};

export default SkipPanVerification;
